import type { Room } from '@/shared/types/store'

export const CHAT_GALLERY_ATTACHMENTS_ENABLED = true

export const isChatGalleryVisible = (room?: Pick<Room, 'isGroup'>) => {
  if (room?.isGroup) {
    return true
  }

  return CHAT_GALLERY_ATTACHMENTS_ENABLED
}
